<template>
  <div></div>
</template>
<script lang="ts">
import { useDialog, useLoadingBar } from 'naive-ui';

export default {
  name: 'DialogContent',
  setup() {
    //挂载在 window 方便与在js中使用
    window['$dialog'] = useDialog();
    window['$loading'] = useLoadingBar();
  },
};
</script>
